import { CatalogObject } from '../catalog-object';
import { ImporterConverterOptions } from '../PointCloudViz/jobs';
import { Project, ProjectType } from '../project/project';
import { TooltipIcon } from '../tooltip-icon';

export enum JobSiteDetailMenuOptions {
    EDIT_PROJECT = 'EDIT_PROJECT',
    DELETE_PROJECT = 'DELETE_PROJECT',
    EDIT_PROJECT_PERMISSIONS = 'EDIT_PROJECT_PERMISSIONS',
    OPEN_DEFAULT_VIEWER = 'OPEN_DEFAULT_VIEWER',
}

export enum ProjectDataEnum {
    pointCloud = 'PointCloud',
    designData = 'Design data',
    controlPoint = 'Control point',
}

export type JobSiteReferenceType = ProjectDataEnum.designData | ProjectDataEnum.controlPoint;
export type ProjectDataType = JobSiteReferenceType | ProjectDataEnum.pointCloud;

export interface JobSiteLayerDetail {
    name: string;
    type: ProjectDataType;
    layerId: number | null;
    visible: boolean;
    projectType?: ProjectType;
    uuid?: string;
    projectId?: number;
    source?: string | null;
    category?: string;
}

export interface JobSiteToc {
    date: string;
    children: JobSiteLayerDetail[];
    visible: boolean;
}
export interface Snapshot {
    jobSiteId: number;
    projectId: number;
    dataType: ProjectDataType;
    url: string | null;
    uuid: string;
    generatedAt: Date;
    generatedOptions: GeneratedOptions;
}

export interface GeneratedOptions {
    layerId: number | null;
}

export interface JobSiteDataCount {
    scan: number;
    referenceData: number;
    earthworks: number;
}

export interface JobSite extends CatalogObject {
    /**Defines some transformations to paint on a plane*/
    horizProjectionEPSG: string | null;
    /**The hypothetical shape of the earth, coinciding with mean sea level and its imagined extension under (or over) land areas. */
    geoid: string | null;
    snapshotType: string;
    sampleDistance: number;
    projects: Project[];
    location: number[];
    status: string;
    snapshots?: Snapshot[];
    data?: any;
    owner?: string;
    dataCount?: JobSiteDataCount;
    controlPointsFiles: unknown[];
    designDataFiles: unknown[];
}

export type DeleteJobSiteOptions = Partial<{
    removeChildProjects: boolean;
    removeLayers: boolean;
    removeGCPFiles: boolean;
    removeDesignDataFiles: boolean;
}>;

export interface JobSiteCreationData {
    description: string;
    geoid: string;
    horizProjectionEPSG: string;
    name: string;
    sampleDistance: number;
    snapshotType: string;
}

export interface JobSiteProject extends Project {
    icon?: TooltipIcon;
}

export interface JobSiteReferenceData {
    layerId: number;
    inputFiles: string[];
    dataType: JobSiteReferenceType;
    options?: ImporterConverterOptions;
}
